import { FulfillmentGroupPickStatus } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const setFulfillmentGroupPickStatus = {
  name: "setFulfillmentGroupPickStatus" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    pickStatus: createEnum(FulfillmentGroupPickStatus, {
      enumName: "FulfillmentGroupPickStatus",
    }),
  }),
  output: z.object({ success: z.boolean(), message: z.string().nullish() }),
};
